import type { FC } from 'react';

import { buttonVariant } from '../MuiButton/MuiButton';

import { MuiCustomLoadingButton } from './MuiLoadingButton.style';

import type { MuiButtonProps } from '../MuiButton/MuiButton';

export type MuiLoadingButtonProps = MuiButtonProps & {
  loading?: boolean;
};

export const MuiLoadingButton: FC<MuiLoadingButtonProps> = ({
  loading = false,
  variant = 'outlined',
  size = 'large',
  color,
  isDisabled,
  startIcon,
  endIcon,
  label,
  isStopPropagation = true,
  type = 'button',
  onClick,
  ...args
}) => {
  const selectVariant = buttonVariant[variant || 'outlined']!;

  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (isStopPropagation) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (onClick) {
      onClick(e);
    }
  };
  return (
    <MuiCustomLoadingButton
      {...args}
      loading={loading}
      className={selectVariant.className}
      variant={selectVariant.variant}
      color={color}
      size={size}
      disabled={isDisabled}
      startIcon={startIcon}
      endIcon={endIcon}
      onClick={handleClick}
      type={type}
    >
      {label}
    </MuiCustomLoadingButton>
  );
};
